import React from "react";
import { Col, Form, Input, Modal, Row, Select } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Option } from "antd/es/mentions";
import { REGIONS } from "../../../../../constants/CompanyConstants";

const EditUserModal = ({ visible, onCancel, onOk, form, userToEdit, companies }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t("edit_user_data", {
        user: !!userToEdit ? userToEdit.userFirstName + " " + userToEdit.userLastName : "",
      })}
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      okText={t("save")}
      cancelText={t("close")}
    >
      <Form layout="vertical" form={form} onFinish={onOk}>
        <Row gutter={16}>
          <Col lg={12}>
            <Form.Item
              name={"userFirstName"}
              label={t("user.first_name")}
              rules={[
                {
                  required: true,
                  message: t("form.enter_user_firstName"),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col lg={12}>
            <Form.Item
              name={"userLastName"}
              label={t("user.last_name")}
              rules={[
                {
                  required: true,
                  message: t("form.enter_user_lastName"),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col lg={24}>
            <Form.Item
              name={"userPhoneNumber"}
              label={t("user.phone")}
              rules={[
                {
                  required: true,
                  message: t("form.enter_phone"),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col lg={24}>
            <Form.Item
              name={"userCustomerId"}
              label={t("user.company")}
              rules={[
                {
                  required: true,
                  message: t("form.enter_customer_name"),
                },
              ]}
              tooltip={{ title: t("select_customer_tooltip"), icon: <InfoCircleOutlined /> }}
            >
              <Select showSearch optionFilterProp="children" allowClear placeholder={t("form.choose_company")}>
                {companies.map((company) => (
                  <Option key={company.customerId} value={company.customerId}>
                    {company.customerName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col lg={12}>
            <Form.Item name="userRegion" label={t("region")}>
              <Select className="mr-2">
                {REGIONS.map((region) => (
                  <Option key={region}>{region}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EditUserModal;
